import { MapDrawingConfig } from "../canvas-drawing";

export const drawDotGrid = ({
  map,
  canvasElement,
  project,
  pointerLocation,
  dotGridSpacing,
  elementToHighlight,
  selectedElement,
}: MapDrawingConfig) => {
  if (!dotGridSpacing) {
    return;
  }
  const ctx = canvasElement.current.getContext("2d");
  //use dot grid spacing to draw a grid 2px dots every increment of dotGridSpacing
  //for the entire ctx.
  ctx.fillStyle = "gray";
  ctx.strokeStyle = "black";
  ctx.lineWidth = 1;
  ctx.beginPath();
  for (
    let x = 0;
    x < map.current.getContainer().clientWidth;
    x += dotGridSpacing
  ) {
    for (
      let y = 0;
      y < map.current.getContainer().clientHeight;
      y += dotGridSpacing
    ) {
      ctx.fillRect(x, y, 2, 2);
    }
  }
  ctx.closePath();
};
